export interface Landmark {
  id: string
  name: string
  type: 'Monument' | 'Building' | 'Park' | 'Religious' | 'Historical'
  location: string
  neighborhood: string
  image: string
  description: string
  significance: string
  yearEstablished: string
  visitInfo: {
    hours: string
    entryFee: string
    accessibility: string
  }
}

export const landmarks: Landmark[] = [
  {
    id: 'kicc',
    name: 'Kenyatta International Convention Centre (KICC)',
    type: 'Building',
    location: 'Harambee Avenue, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1611348524140-53c9a25263d6?w=800&q=80',
    description:
      "Iconic 28-story cylindrical tower and Nairobi's most recognizable landmark. The helipad offers 360° views of the city.",
    significance:
      "Symbol of Kenya's independence and development. Hosts major international conferences and events.",
    yearEstablished: '1973',
    visitInfo: {
      hours: 'Daily 8:00 AM - 6:00 PM',
      entryFee: 'Rooftop access: KES 500',
      accessibility: 'Elevator to viewing deck',
    },
  },
  {
    id: 'parliament-buildings',
    name: 'Parliament Buildings',
    type: 'Building',
    location: 'Parliament Road, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=800&q=80',
    description:
      "Seat of Kenya's bicameral legislature. Features distinctive clock tower and colonial architecture.",
    significance:
      "Center of Kenya's democracy and legislative process since independence.",
    yearEstablished: '1954',
    visitInfo: {
      hours: 'Tours by appointment only',
      entryFee: 'Free with prior arrangement',
      accessibility: 'Limited access, security clearance required',
    },
  },
  {
    id: 'uhuru-monument',
    name: 'Uhuru Monument',
    type: 'Monument',
    location: 'Uhuru Park, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1569098644584-210bcd375b59?w=800&q=80',
    description:
      "Monument commemorating Kenya's independence. Features hands holding a dove symbolizing freedom.",
    significance:
      "Marks the spot where Kenya's independence flag was first raised on December 12, 1963.",
    yearEstablished: '1963',
    visitInfo: {
      hours: 'Always accessible',
      entryFee: 'Free',
      accessibility: 'Fully accessible',
    },
  },
  {
    id: 'nairobi-railway-station',
    name: 'Nairobi Railway Station',
    type: 'Historical',
    location: 'Station Road, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1474487548417-781cb71495f3?w=800&q=80',
    description:
      "Historic railway station marking Nairobi's birthplace. The Uganda Railway made Nairobi what it is today.",
    significance:
      'Birthplace of Nairobi - the city began as a railway depot in 1899.',
    yearEstablished: '1899',
    visitInfo: {
      hours: 'Station operates 24/7',
      entryFee: 'Free to view',
      accessibility: 'Public access',
    },
  },
  {
    id: 'all-saints-cathedral',
    name: "All Saints' Cathedral",
    type: 'Religious',
    location: 'Kenyatta Avenue, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1548625149-fc4a29cf7092?w=800&q=80',
    description:
      "Anglican cathedral and one of Nairobi's most beautiful religious buildings. Gothic architecture with stunning stained glass.",
    significance:
      'Mother church of the Anglican Church of Kenya. Historic site of national prayers and ceremonies.',
    yearEstablished: '1917',
    visitInfo: {
      hours: 'Daily 8:00 AM - 5:00 PM, Services on Sunday',
      entryFee: 'Free entry, donations welcome',
      accessibility: 'Wheelchair accessible',
    },
  },
  {
    id: 'nyayo-monument',
    name: 'Nyayo Monument',
    type: 'Monument',
    location: 'Central Park, CBD',
    neighborhood: 'CBD',
    image:
      'https://images.unsplash.com/photo-1569098644584-210bcd375b59?w=800&q=80',
    description:
      'Monument featuring footsteps symbolizing following in the footsteps of founding father Jomo Kenyatta.',
    significance:
      'Represents continuity of leadership and national unity under President Daniel arap Moi\'s "Nyayo" philosophy.',
    yearEstablished: '1988',
    visitInfo: {
      hours: 'Always accessible',
      entryFee: 'Free',
      accessibility: 'Fully accessible',
    },
  },
]
